import { gql } from '@apollo/client';

export const GET_POST_REPLY_DRAFTS_QUERY = gql`
    query getPostReplyDrafts($userId: String!) {
        getPostReplyDrafts(userId: $userId) {
            id
            parentPostId
            status
            hasStoryAnalysis
            storyAnalysis
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            article
            createdAt
            updatedAt
        }
    }
`;
